export default {
  title: {
    id: 'us_telco_comparators_landing_page_hero_title',
    defaultMessage: 'Phone plans for less, only on Back Market',
  },
  subtitle: {
    id: 'us_telco_comparators_landing_page_hero_subtitle',
    defaultMessage:
      'We partnered with the best carriers to get you exclusive discounts when you bundle your phone with a no-contract plan.',
  },
  imageAlt: {
    id: 'us_telco_comparators_landing_page_hero_image_alt',
    defaultMessage:
      'A smartphone alongside cards for the Visible, US Mobile, and Noble Mobile carrier plans',
  },
  ctaExplorePlans: {
    id: 'us_telco_comparators_landing_page_hero_cta_explore_plans',
    defaultMessage: 'Explore plans',
  },
  ctaCalculateSavings: {
    id: 'us_telco_comparators_landing_page_hero_cta_calculate_savings',
    defaultMessage: 'Calculate savings',
  },
  ctaFaq: {
    id: 'us_telco_comparators_landing_page_hero_cta_faq',
    defaultMessage: 'FAQ',
  },
}
